// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import { sh3RegisterApi } from "../../../api/ShThreeApi";

// // ── Column definitions matching the SH-3 image exactly ───────────────────────
// const COLUMNS = [
//   { key: "serialNo",                      label: "S.No",                                    col: "(1)" },
//   { key: "referenceToRegisterOfMembers",  label: "Reference to entry in register of members", col: "(2)" },
//   { key: "nameOfAllottee",                label: "Name of the allottee",                    col: "(3)" },
//   { key: "statusOfAllottee",              label: "Status of the allottee – whether director or employee", col: "(4)" },
//   { key: "boardResolutionDate",           label: "Date of passing of Board resolution",      col: "(5)" },
//   { key: "specialResolutionDate",         label: "Date of the special resolution authorizing the issue of sweat equity shares", col: "(6)" },
//   { key: "issueDate",                     label: "Date of issue of sweat equity shares",     col: "(7)" },
//   { key: "numberOfSharesIssued",          label: "Number of sweat equity shares issued",     col: "(8)" },
//   { key: "certificateOrFolioNo",          label: "Certificate No. / Folio No.",              col: "(9)" },
//   { key: "faceValuePerShare",             label: "Face value of the share",                  col: "(10)" },
//   { key: "issuePricePerShare",            label: "Price at which the shares are issued",     col: "(11)" },
//   { key: "amountTreatedAsPaidUp",         label: "Amount treated as paid up",                col: "(12)" },
//   { key: "considerationReceivedInCash",   label: "Consideration received in cash",           col: "(13)" },
//   { key: "considerationOtherThanCash",    label: "Particulars of consideration on other than cash", col: "(14)" },
//   { key: "lockInPeriodInMonths",          label: "Lock in period",                           col: "(15)" },
//   { key: "lockInExpiryDate",              label: "Date of expiry of lock-in-period",         col: "(16)" },
//   { key: "remarks",                       label: "Remarks, if any",                          col: "(17)" },
//   { key: "dateOfJoining",                 label: "Date of Joining",                          col: "(18)" },
//   { key: "fairValueObtainedByValuer",     label: "Fair value obtained by Valuer",            col: "(19)" },
//   { key: "basisOfValuation",              label: "Basis of Valuation",                       col: "(20)" },
//   { key: "nameOfValuer",                  label: "Name of Valuer",                           col: "(21)" },
// ];

// const BLANK_ENTRY = {
//   referenceToRegisterOfMembers: "",
//   nameOfAllottee: "",
//   statusOfAllottee: "",
//   boardResolutionDate: "",
//   specialResolutionDate: "",
//   issueDate: "",
//   numberOfSharesIssued: "",
//   certificateOrFolioNo: "",
//   faceValuePerShare: "",
//   issuePricePerShare: "",
//   amountTreatedAsPaidUp: "",
//   considerationReceivedInCash: "",
//   considerationOtherThanCash: "",
//   lockInPeriodInMonths: "",
//   lockInExpiryDate: "",
//   remarks: "",
//   dateOfJoining: "",
//   fairValueObtainedByValuer: "",
//   basisOfValuation: "",
//   nameOfValuer: "",
// };

// // ── Modal for adding a new entry ──────────────────────────────────────────────
// const AddEntryModal = ({ onClose, onSave, saving }) => {
//   const [form, setForm] = useState({ ...BLANK_ENTRY });

//   const dateFields = [
//     "boardResolutionDate","specialResolutionDate","issueDate",
//     "lockInExpiryDate","dateOfJoining",
//   ];
//   const numberFields = [
//     "numberOfSharesIssued","faceValuePerShare","issuePricePerShare",
//     "amountTreatedAsPaidUp","considerationReceivedInCash",
//     "lockInPeriodInMonths","fairValueObtainedByValuer",
//   ];

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
//       <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
//         {/* Modal Header */}
//         <div className="bg-primary text-white px-6 py-3 rounded-t-xl flex justify-between items-center">
//           <h2 className="font-bold text-sm uppercase tracking-widest">Add New SH-3 Entry</h2>
//           <button onClick={onClose} className="text-white hover:text-red-300 text-xl font-bold">✕</button>
//         </div>

//         {/* Modal Body */}
//         <div className="overflow-y-auto p-4 flex-1">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
//             {COLUMNS.filter(c => c.key !== "serialNo").map(col => (
//               <div key={col.key}>
//                 <label className="block text-xs font-medium text-gray-600 mb-1">
//                   {col.col} {col.label}
//                 </label>
//                 <input
//                   type={dateFields.includes(col.key) ? "date" : numberFields.includes(col.key) ? "number" : "text"}
//                   value={form[col.key] || ""}
//                   onChange={e => setForm(prev => ({ ...prev, [col.key]: e.target.value }))}
//                   className="w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-blue-400"
//                 />
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Modal Footer */}
//         <div className="px-6 py-3 border-t flex justify-end gap-3">
//           <button
//             onClick={onClose}
//             className="px-4 py-2 text-xs border border-gray-300 rounded-md hover:bg-gray-50 font-semibold uppercase"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={() => onSave(form)}
//             disabled={saving}
//             className="px-4 py-2 text-xs bg-green-600 text-white rounded-md hover:bg-green-700 disabled:bg-gray-400 font-semibold uppercase"
//           >
//             {saving ? "Saving..." : "Save Entry"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ── Main SH-3 Viewer ──────────────────────────────────────────────────────────
// const Sh3Viewer = ({ selectedClientData }) => {
//   const token = useSelector((state) => state.auth?.access_token);
//    const accountId = selectedClientData?.accountId || selectedClientData?.id;

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//     const [error, setError] = useState(null);
  
//   const [saving, setSaving] = useState(false);
//   const [status, setStatus] = useState(null); // { type: "success"|"error", message }
//   const [generatingPdf, setGeneratingPdf] = useState(false);

//   // Fetch data when accountId changes
//  useEffect(() => {
//   if (accountId && token) {
//     console.log("SH3 fetching for accountId:", accountId);
//     fetchData();
//   }
// }, [accountId, token]);

// const fetchData = async () => {
//   if (!accountId || !token) {
//     console.warn("SH-3: missing accountId or token");
//     return;
//   }

//   setLoading(true);
//   setError(null);

//   try {
//     const res = await sh3RegisterApi.fetchSh3Register(accountId, token);

//     const list =
//       Array.isArray(res)
//         ? res
//         : Array.isArray(res?.data)
//         ? res.data
//         : [];

//     setData(list);
//   } catch (err) {
//     console.error("SH-3 fetch error:", err);
//     setError("No data available for SH-3");
//   } finally {
//     setLoading(false);
//   }
// };

//   // Add new entry via POST
//   const handleSaveEntry = async (form) => {
//     setSaving(true);
//     setStatus(null);
//     try {
//       const payload = {
//         ...form,
//         numberOfSharesIssued:       form.numberOfSharesIssued       ? parseInt(form.numberOfSharesIssued, 10)   : null,
//         faceValuePerShare:           form.faceValuePerShare           ? parseFloat(form.faceValuePerShare)        : null,
//         issuePricePerShare:          form.issuePricePerShare          ? parseFloat(form.issuePricePerShare)       : null,
//         amountTreatedAsPaidUp:       form.amountTreatedAsPaidUp       ? parseFloat(form.amountTreatedAsPaidUp)    : null,
//         considerationReceivedInCash: form.considerationReceivedInCash ? parseFloat(form.considerationReceivedInCash) : null,
//         lockInPeriodInMonths:        form.lockInPeriodInMonths        ? parseInt(form.lockInPeriodInMonths, 10)   : null,
//         fairValueObtainedByValuer:   form.fairValueObtainedByValuer   ? parseFloat(form.fairValueObtainedByValuer): null,
//       };

//       const res = await fetch(
//         `/api/sh3-register?accountId=${accountId}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify(payload),
//         }
//       );
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const created = await res.json();
//       setData(prev => [...prev, created]);
//       setShowModal(false);
//       setStatus({ type: "success", message: "Entry added successfully!" });
//     } catch (err) {
//       setStatus({ type: "error", message: err.message || "Failed to add entry." });
//     } finally {
//       setSaving(false);
//     }
//   };

//   // PDF generation using browser print (landscape)
//   const handleDownloadPdf = () => {
//     setGeneratingPdf(true);
//     const printContent = document.getElementById("sh3-table-print");
//     const originalBody = document.body.innerHTML;
//     document.body.innerHTML = `
//       <style>
//         @page { size: A3 landscape; margin: 10mm; }
//         body { font-family: Arial, sans-serif; font-size: 7px; }
//         table { border-collapse: collapse; width: 100%; }
//         th, td { border: 1px solid #333; padding: 2px 3px; text-align: center; vertical-align: middle; }
//         th { background-color: #1e3a5f; color: white; font-size: 6.5px; }
//         .header-title { text-align: center; margin-bottom: 4px; }
//         .header-title h1 { font-size: 12px; font-weight: bold; }
//         .header-title h2 { font-size: 10px; }
//         .header-title p  { font-size: 8px; }
//         td { font-size: 6.5px; }
//       </style>
//       ${printContent.outerHTML}
//     `;
//     window.print();
//     document.body.innerHTML = originalBody;
//     window.location.reload();
//   };

//   const fmt = (val) => (val === null || val === undefined || val === "") ? "—" : String(val);

//   return (
//     <div>
//       {/* ── Header ── */}
//       <div className="bg-white border-b-4 px-6 py-2 mb-2 text-center shadow-sm rounded-t-lg">
//         <h1 className="text-2xl font-black uppercase tracking-tight">Form No. SH - 3</h1>
//         <h2 className="text-lg font-bold mt-1">Register of Sweat Equity Shares</h2>
//         <p className="text-[10px] italic text-slate-500 mt-1 max-w-4xl mx-auto">
//           [Pursuant to section 54 of the Companies Act, 2013 and rule 8(14) of the Companies
//           (Share Capital and Debentures) Rules 2014]
//         </p>
//       </div>

//       {/* ── Controls ── */}
//       <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-3 mb-2 flex flex-wrap gap-3 items-end justify-between">
   

//         <div className="flex gap-2">
//           <button
//             onClick={() => { setShowModal(true); setStatus(null); }}
//             disabled={!accountId}
//             className="bg-primary text-white text-xs px-4 py-2 rounded-md font-bold uppercase shadow-sm hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition"
//           >
//             + Add New Entry
//           </button>
//           <button
//             onClick={handleDownloadPdf}
//             disabled={data.length === 0 || generatingPdf}
//             className="bg-green-600 text-white text-xs px-4 py-2 rounded-md font-bold uppercase shadow-sm hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition"
//           >
//             ⬇ Download PDF
//           </button>
//         </div>
//       </div>

//       {/* ── Status Banner ── */}
//       {status && (
//         <div className={`mb-2 px-4 py-3 rounded-lg text-sm font-medium border ${
//           status.type === "success"
//             ? "bg-green-50 text-green-800 border-green-200"
//             : "bg-red-50 text-red-800 border-red-200"
//         }`}>
//           {status.message}
//         </div>
//       )}

//       {/* ── Table ── */}
//       {loading ? (
//         <div className="text-center py-10 text-gray-500 text-sm">Loading...</div>
//       ) : data.length === 0 ? (
//         <div className="text-center py-10 text-gray-400 text-sm italic">
//           {accountId ? "No entries found for this company." : "Select a company to view records."}
//         </div>
//       ) : (
//         <div className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden">
//           <div className="overflow-x-auto">
//             <div id="sh3-table-print">
//               {/* Print header (hidden on screen) */}
//               <div className="header-title hidden">
//                 <h1>Form No. SH - 3</h1>
//                 <h2>Register of Sweat Equity Shares</h2>
//                 <p>[Pursuant to section 54 of the Companies Act, 2013 and rule 8(14) of the Companies (Share Capital and Debentures) Rules 2014]</p>
//               </div>

//               <table className="w-full text-[10px] border-collapse min-w-[2400px]">
//                 <thead>
//                   {/* Column number row */}
//                   <tr className="bg-slate-800 text-white">
//                     {COLUMNS.map(col => (
//                       <th
//                         key={col.key}
//                         className="border border-slate-600 px-1 py-1 text-center font-bold text-[9px] whitespace-nowrap"
//                       >
//                         {col.col}
//                       </th>
//                     ))}
//                   </tr>
//                   {/* Column label row */}
//                   <tr className="bg-slate-700 text-white">
//                     {COLUMNS.map(col => (
//                       <th
//                         key={col.key}
//                         className="border border-slate-600 px-1 py-1.5 text-center font-semibold text-[9px] leading-tight"
//                         style={{ minWidth: col.key === "serialNo" ? 36 : 90, maxWidth: 130 }}
//                       >
//                         {col.label}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.map((row, i) => (
//                     <tr
//                       key={row.id || i}
//                       className={i % 2 === 0 ? "bg-white" : "bg-slate-50"}
//                     >
//                       {COLUMNS.map(col => (
//                         <td
//                           key={col.key}
//                           className="border border-slate-200 px-1.5 py-1 text-center text-[10px] align-middle"
//                         >
//                           {fmt(row[col.key])}
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//           <div className="px-4 py-2 border-t text-xs text-gray-500 text-right">
//             Total entries: <span className="font-bold text-gray-700">{data.length}</span>
//           </div>
//         </div>
//       )}

//       {/* ── Add Entry Modal ── */}
//       {showModal && (
//         <AddEntryModal
//           onClose={() => setShowModal(false)}
//           onSave={handleSaveEntry}
//           saving={saving}
//         />
//       )}
//     </div>
//   );
// };

// export default Sh3Viewer;

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { sh3RegisterApi } from "../../../api/ShThreeApi";
import { Button } from "../../../components/Button";
import { Spinner } from "reactstrap";
import { X } from "lucide-react";

// ── All 21 columns ────────────────────────────────────────────────────────────
const COLUMNS = [
  { key: "serialNo",                      label: "S.No",                                                                      col: "(1)"  },
  { key: "referenceToRegisterOfMembers",  label: "Reference to entry in register of members",                                 col: "(2)"  },
  { key: "nameOfAllottee",                label: "Name of the allottee",                                                       col: "(3)"  },
  { key: "statusOfAllottee",              label: "Status of the allottee – whether director or employee",                      col: "(4)"  },
  { key: "boardResolutionDate",           label: "Date of passing of Board resolution",                                        col: "(5)"  },
  { key: "specialResolutionDate",         label: "Date of the special resolution authorizing the issue of sweat equity shares", col: "(6)"  },
  { key: "issueDate",                     label: "Date of issue of sweat equity shares",                                       col: "(7)"  },
  { key: "numberOfSharesIssued",          label: "Number of sweat equity shares issued",                                       col: "(8)"  },
  { key: "certificateOrFolioNo",          label: "Certificate No. / Folio No.",                                                col: "(9)"  },
  { key: "faceValuePerShare",             label: "Face value of the share",                                                    col: "(10)" },
  { key: "issuePricePerShare",            label: "Price at which the shares are issued",                                       col: "(11)" },
  { key: "amountTreatedAsPaidUp",         label: "Amount treated as paid up",                                                  col: "(12)" },
  { key: "considerationReceivedInCash",   label: "Consideration received in cash",                                             col: "(13)" },
  { key: "considerationOtherThanCash",    label: "Particulars of consideration on other than cash",                            col: "(14)" },
  { key: "lockInPeriodInMonths",          label: "Lock in period",                                                             col: "(15)" },
  { key: "lockInExpiryDate",              label: "Date of expiry of lock-in-period",                                           col: "(16)" },
  { key: "remarks",                       label: "Remarks, if any",                                                            col: "(17)" },
  { key: "dateOfJoining",                 label: "Date of Joining",                                                            col: "(18)" },
  { key: "fairValueObtainedByValuer",     label: "Fair value obtained by Valuer",                                              col: "(19)" },
  { key: "basisOfValuation",              label: "Basis of Valuation",                                                         col: "(20)" },
  { key: "nameOfValuer",                  label: "Name of Valuer",                                                             col: "(21)" },
];

// Split into two parts for display
const PART_ONE   = COLUMNS.slice(0, 11);  // cols (1)–(11)
const PART_TWO   = [COLUMNS[0], ...COLUMNS.slice(11)]; // S.No repeated + cols (12)–(21)

const BLANK_ENTRY = Object.fromEntries(
  COLUMNS.filter(c => c.key !== "serialNo").map(c => [c.key, ""])
);

const dateFields   = ["boardResolutionDate","specialResolutionDate","issueDate","lockInExpiryDate","dateOfJoining"];
const numberFields = ["numberOfSharesIssued","faceValuePerShare","issuePricePerShare","amountTreatedAsPaidUp","considerationReceivedInCash","lockInPeriodInMonths","fairValueObtainedByValuer"];

// ── Sub-table component ────────────────────────────────────────────────────────
const SubTable = ({ columns, data, partLabel, fmt }) => (
  <div className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden">
    {/* Part label */}
    <div className="bg-slate-100 border-b border-slate-200 px-4 py-1.5 flex items-center gap-2">
      <span className="text-[11px] font-bold text-slate-600 uppercase tracking-widest">{partLabel}</span>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-[10px] border-collapse">
        <thead>
          <tr className="bg-slate-800 text-white">
            {columns.map(col => (
              <th key={col.key} className="border border-slate-600 px-2 py-1 text-center font-bold text-[9px] whitespace-nowrap">
                {col.col}
              </th>
            ))}
          </tr>
          <tr className="bg-slate-700 text-white">
            {columns.map(col => (
              <th
                key={col.key}
                className="border border-slate-600 px-2 py-2 text-center font-semibold text-[9px] leading-tight"
                style={{ minWidth: col.key === "serialNo" ? 36 : 100 }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={row.id || i} className={i % 2 === 0 ? "bg-white" : "bg-slate-50"}>
              {columns.map(col => (
                <td key={col.key} className="border border-slate-200 px-2 py-1.5 text-center text-[10px] align-middle">
                  {fmt(row[col.key])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

// ── Add Entry Modal ────────────────────────────────────────────────────────────
const AddEntryModal = ({ onClose, onSave, saving }) => {
  const [form, setForm] = useState({ ...BLANK_ENTRY });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl p-3 shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="flex flex-row items-center justify-between">
          <h1 className="text-2xl font-semibold text-gray-800">
            Add New SH-3 Entry
          </h1>
          <button
            onClick={onClose}
            aria-label="Close"
            type="button"
            className="p-1 rounded-md bg-red-50 hover:bg-red-100 text-red-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            <X size={20} />
          </button>
        </div>
        <div className="overflow-y-auto flex-1">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            {COLUMNS.filter(c => c.key !== "serialNo").map(col => (
              <div key={col.key}>
                <label className="block text-xs font-medium text-gray-600 mb-1">
                  {col.col} {col.label}
                </label>
                <input
                  type={dateFields.includes(col.key) ? "date" : numberFields.includes(col.key) ? "number" : "text"}
                  value={form[col.key] || ""}
                  onChange={e => setForm(prev => ({ ...prev, [col.key]: e.target.value }))}
                  className="w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-row items-center justify-end gap-2">
        <button
            type="button"
            onClick={onClose}
            className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
        >
            Cancel
        </button>
        {saving ? 
        <Button label={<Spinner size={"sm"}/>}/> :
        <Button label={`${saving ? "Update" : "Save Entry"}`} disabled={saving} onClick={() => onSave(form)} />}
      </div>
      </div>
    </div>
  );
};

// ── PDF print styles injected into <head> ─────────────────────────────────────
const PRINT_STYLES = `
  @media print {
    @page { size: A3 landscape; margin: 8mm; }
    body * { visibility: hidden !important; }
    #sh3-pdf-area, #sh3-pdf-area * { visibility: visible !important; }
    #sh3-pdf-area { position: fixed; top: 0; left: 0; width: 100%; }
  }
`;

// ── Main SH-3 Viewer ──────────────────────────────────────────────────────────
const Sh3Viewer = ({ selectedClientData }) => {
  const token     = useSelector((state) => state.auth?.access_token);
  const accountId = selectedClientData?.accountId || selectedClientData?.id;

  const [data,          setData]          = useState([]);
  const [loading,       setLoading]       = useState(false);
  const [showModal,     setShowModal]     = useState(false);
  const [error,         setError]         = useState(null);
  const [saving,        setSaving]        = useState(false);
  const [status,        setStatus]        = useState(null);
  const [generatingPdf, setGeneratingPdf] = useState(false);

  // Inject print styles once
  useEffect(() => {
    const style = document.createElement("style");
    style.id    = "sh3-print-style";
    style.innerHTML = PRINT_STYLES;
    if (!document.getElementById("sh3-print-style")) document.head.appendChild(style);
    return () => document.getElementById("sh3-print-style")?.remove();
  }, []);

  useEffect(() => {
    if (accountId && token) fetchData();
  }, [accountId, token]);

  const fetchData = async () => {
    if (!accountId || !token) return;
    setLoading(true);
    setError(null);
    try {
      const res  = await sh3RegisterApi.fetchSh3Register(accountId, token);
      const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
      setData(list);
    } catch (err) {
      setError("No data available for SH-3");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveEntry = async (form) => {
    setSaving(true);
    setStatus(null);
    try {
      const payload = {
        ...form,
        numberOfSharesIssued:       form.numberOfSharesIssued       ? parseInt(form.numberOfSharesIssued, 10)        : null,
        faceValuePerShare:           form.faceValuePerShare           ? parseFloat(form.faceValuePerShare)             : null,
        issuePricePerShare:          form.issuePricePerShare          ? parseFloat(form.issuePricePerShare)            : null,
        amountTreatedAsPaidUp:       form.amountTreatedAsPaidUp       ? parseFloat(form.amountTreatedAsPaidUp)         : null,
        considerationReceivedInCash: form.considerationReceivedInCash ? parseFloat(form.considerationReceivedInCash)   : null,
        lockInPeriodInMonths:        form.lockInPeriodInMonths        ? parseInt(form.lockInPeriodInMonths, 10)        : null,
        fairValueObtainedByValuer:   form.fairValueObtainedByValuer   ? parseFloat(form.fairValueObtainedByValuer)     : null,
      };
      const res = await fetch(`/api/sh3-register?accountId=${accountId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const created = await res.json();
      setData(prev => [...prev, created]);
      setShowModal(false);
      setStatus({ type: "success", message: "Entry added successfully!" });
    } catch (err) {
      setStatus({ type: "error", message: err.message || "Failed to add entry." });
    } finally {
      setSaving(false);
    }
  };

  // PDF: reveal hidden print area then print
  const handleDownloadPdf = () => {
    setGeneratingPdf(true);
    setTimeout(() => {
      window.print();
      setGeneratingPdf(false);
    }, 300);
  };
const fmt = (val) => (val === null || val === undefined || val === "") ? "—" : String(val);

// ── Shared table builder for PDF area ──────────────────────────────────────
const PrintSubTable = ({ columns, partLabel }) => (
  <div style={{ marginBottom: 12, color: "#000" }}>
    <div
      style={{
        fontWeight: "bold",
        fontSize:12,
        color: "#000",   // changed from #444
        marginBottom: 4,
        textTransform: "uppercase",
        letterSpacing: 1
      }}
    >
      {partLabel}
    </div>

    <table
      style={{
        borderCollapse: "collapse",
        width: "100%",
        fontSize: 12,
        color: "#000"  // force all table text black
      }}
    >
      <thead>
        <tr style={{ background: "#1e3a5f", color: "#000" }}>
          {columns.map(col => (
            <th
              key={col.key}
              style={{
                border: "1px solid #000", // darker border
                padding: "2px 3px",
                textAlign: "center",
                fontSize: 12,
                whiteSpace: "nowrap",
                color: "#000"
              }}
            >
              {col.col}
            </th>
          ))}
        </tr>

        <tr style={{ background: "#2d4f7c", color: "#000" }}>
          {columns.map(col => (
            <th
              key={col.key}
              style={{
                border: "1px solid #000",
                padding: "3px 3px",
                textAlign: "center",
                fontSize: 12,
                lineHeight: 1.3,
                color: "#000",
                minWidth: col.key === "serialNo" ? 28 : 80
              }}
            >
              {col.label}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {data.map((row, i) => (
          <tr key={row.id || i} style={{ background: "#fff" }}>
            {columns.map(col => (
              <td
                key={col.key}
                style={{
                  border: "1px solid #000",
                  padding: "2px 3px",
                  textAlign: "center",
                  fontSize: 10,
                  verticalAlign: "middle",
                  color: "#000"
                }}
              >
                {fmt(row[col.key])}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  );

  return (
    <div>
      {/* ── Heading ── */}
      <div className="bg-white border-b-4 px-6 py-2 mb-2 text-center shadow-sm rounded-t-lg">
        <h1 className="text-2xl font-black uppercase tracking-tight">Form No. SH - 3</h1>
        <h2 className="text-lg font-bold mt-1">Register of Sweat Equity Shares</h2>
        <p className="text-[10px] italic text-slate-500 mt-1 max-w-4xl mx-auto">
          [Pursuant to section 54 of the Companies Act, 2013 and rule 8(14) of the Companies
          (Share Capital and Debentures) Rules 2014]
        </p>
      </div>

      {/* ── Controls ── */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-3 mb-2 flex flex-wrap gap-3 items-end justify-between">
        <div className="flex gap-2">
          <button
            onClick={() => { setShowModal(true); setStatus(null); }}
            disabled={!accountId}
            className="bg-primary text-white text-xs px-4 py-2 rounded-md font-bold uppercase shadow-sm hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition"
          >
            + Add New Entry
          </button>
          <button
            onClick={handleDownloadPdf}
            disabled={data.length === 0 || generatingPdf}
            className="bg-green-600 text-white text-xs px-4 py-2 rounded-md font-bold uppercase shadow-sm hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition"
          >
            ⬇ Download PDF
          </button>
        </div>
      </div>

      {/* ── Status Banner ── */}
      {status && (
        <div className={`mb-2 px-4 py-3 rounded-lg text-sm font-medium border ${
          status.type === "success"
            ? "bg-green-50 text-green-800 border-green-200"
            : "bg-red-50 text-red-800 border-red-200"
        }`}>
          {status.message}
        </div>
      )}

      {/* ── Screen Tables (split into Part 1 + Part 2) ── */}
      {loading ? (
        <div className="text-center py-10 text-gray-500 text-sm">Loading...</div>
      ) : data.length === 0 ? (
        <div className="text-center py-10 text-gray-400 text-sm italic">
          {accountId ? "No entries found for this company." : "Select a company to view records."}
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {/* ── Part 1: Columns (1)–(11) ── */}
          <SubTable
            columns={PART_ONE}
            data={data}
            partLabel="Part 1 — Columns (1) to (11)"
            fmt={fmt}
          />

          {/* ── Part 2: S.No + Columns (12)–(21) ── */}
          <SubTable
            columns={PART_TWO}
            data={data}
            partLabel="Part 2 — Columns (12) to (21)"
            fmt={fmt}
          />

          <div className="text-xs text-gray-500 text-right px-1">
            Total entries: <span className="font-bold text-gray-700">{data.length}</span>
          </div>
        </div>
      )}

      {/* ── Hidden PDF Print Area ── */}
      {data.length > 0 && (
        <div id="sh3-pdf-area" style={{ display: "none" }}>
          {/* display:none on screen; @media print makes it visible */}
          <style>{`
            @media print {
              #sh3-pdf-area { display: block !important; }
            }
          `}</style>

          {/* PDF Header */}
          <div style={{ textAlign: "center", marginBottom: 10, fontFamily: "Arial, sans-serif" }}>
            <h1 style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>Form No. SH - 3</h1>
            <h2 style={{ fontSize: 11, margin: "2px 0" }}>Register of Sweat Equity Shares</h2>
            <p style={{ fontSize: 7.5, margin: 0, color:"black", fontStyle: "italic" }}>
              [Pursuant to section 54 of the Companies Act, 2013 and rule 8(14) of the
              Companies (Share Capital and Debentures) Rules 2014]
            </p>
          </div>

          {/* PDF Part 1 */}
          <PrintSubTable columns={PART_ONE} partLabel="Part 1 — Columns (1) to (11)" />

          {/* spacer */}
          <div style={{ height: 16 }} />

          {/* PDF Part 2 */}
          <PrintSubTable columns={PART_TWO} partLabel="Part 2 — Columns (12) to (21)" />
        </div>
      )}

      {/* ── Add Entry Modal ── */}
      {showModal && (
        <AddEntryModal
          onClose={() => setShowModal(false)}
          onSave={handleSaveEntry}
          saving={saving}
        />
      )}
    </div>
  );
};

export default Sh3Viewer;